module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_14.160ea452.jpg";